// Identifiants d'entités — générateur unique, stable et compatible Supabase.
//
// Toutes les entités du frontend (immeubles, biens, locataires, contrats,
// abonnements, paiements, territoires, administrateurs, comptes, activités,
// journal d'audit...) doivent utiliser CE générateur. Il produit un UUID v4
// (`crypto.randomUUID`) exactement au format attendu par une colonne
// `uuid primary key default gen_random_uuid()` côté Supabase.
//
// Un préfixe lisible facultatif est conservé devant l'UUID pour faciliter le
// débogage en frontend (ex. `immeuble-…`). Ce préfixe sera simplement retiré au
// moment de la migration : la base générera elle-même ses identifiants et les
// références croisées resteront valides puisqu'elles utilisent la même valeur.
//
// Aucune dépendance au navigateur au-delà de `crypto`, avec un repli sûr si
// l'API n'est pas disponible (contexte non sécurisé).

/** UUID v4 (fonction native si disponible, sinon repli déterministe). */
export function createUuid(): string {
  const cryptoObject = typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
  if (cryptoObject && typeof cryptoObject.randomUUID === "function") {
    return cryptoObject.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

/**
 * Identifiant unique d'entité, éventuellement préfixé pour la lisibilité.
 * Exemple : createId("bien") => "bien-3f9c1d2e-…".
 */
export function createId(prefix?: string): string {
  const uuid = createUuid();
  return prefix ? `${prefix}-${uuid}` : uuid;
}

/** Vrai si la valeur a la forme d'un UUID (utile lors de la migration base). */
export function isUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim());
}